<template>
    <Bulletins :Mode="false"  Type="2"></Bulletins>
</template>

<script>
import Vue from 'vue';
import Bulletins from '@/components/DPEBB/Administrator/Bulletins.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function(){
        return {
        AppServiceID :2,
        }
    },
    components: { 
        Bulletins, 
    },
created: function() { 
    this.$emit('update:layout', LayoutDefault);
    this.AppServiceID = this.$store.getters.GetMedicalID;

},    
beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetMedicalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetMedicalID);
    },
}
</script>

<style>

</style>
